export default __webpack_public_path__ + "static/media/planned-for-vessel.76338ac9.svg";